import React, { useEffect } from 'react';
import { useAsset } from '../hooks/useAsset';
import { Language, t } from '../data/translations';

type GameMode = 'MAIN_MENU' | 'GAME_MODE_SELECT' | 'MULTIPLAYER_MENU' | 'PLAYING' | 'OPTIONS';

interface InGameMenuProps {
  onResume: () => void;
  onNavigate: (mode: GameMode) => void;
  onReturnToMainMenu: () => void;
  language: Language;
}

const InGameMenu: React.FC<InGameMenuProps> = ({ onResume, onNavigate, onReturnToMainMenu, language }) => {
  const menuBg = useAsset('ui.menu.bg');
  const btnPrimary = useAsset('ui.menu.btnPrimary');
  useEffect(() => {
    document.body.classList.add('menu-open');
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, []);

  return (
    <div className="absolute inset-0 bg-black/70 backdrop-blur-sm flex flex-col items-center justify-center z-[100] animate-[fadeIn_0.3s_ease-out]" style={{ backgroundImage: `url(${menuBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <h2 className="text-5xl font-bold text-white mb-10">{t('ui.paused', language)}</h2>
      <div className="flex flex-col gap-4 w-64">
        <button
          onClick={onResume}
          className="text-white font-bold text-lg py-3 px-6 rounded-lg transition-all duration-300 shadow-lg transform hover:scale-105"
          style={{ backgroundImage: `url(${btnPrimary})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
          {t('ui.resume', language)}
        </button>
        <button
          onClick={() => onNavigate('OPTIONS')}
          className="text-white font-bold text-lg py-3 px-6 rounded-lg transition-all duration-300 shadow-lg transform hover:scale-105"
          style={{ backgroundImage: `url(${btnPrimary})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
          {t('ui.options', language)}
        </button>
        <button
          onClick={onReturnToMainMenu}
          className="text-white font-bold text-lg py-3 px-6 rounded-lg transition-all duration-300 shadow-lg transform hover:scale-105"
          style={{ backgroundImage: `url(${btnPrimary})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
          {t('ui.mainMenu', language)}
        </button>
      </div>
    </div>
  );
};

export default InGameMenu;

